import Image from 'next/image';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import useMailingListSignup, { OnSubmitData } from 'hooks/useMailingListSignup';

export default function SignUpForm(): React.ReactElement {
  const [isValid, setValid] = useState<boolean>(false);
  const onMailingListSignupSubmit = useMailingListSignup();
  const {
    register,
    handleSubmit,
    resetField,
    setError,
    formState: { errors }
  } = useForm<OnSubmitData>({ defaultValues: { referralSource: 'blog page' } });

  const onSubmit = async (data: OnSubmitData) => {
    const result = await onMailingListSignupSubmit(data);
    if (result.success) {
      resetField('emailAddress');
    } else {
      setError('emailAddress', result.error);
    }
  };

  const validateEmail = (email: string): void => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const result = regex.test(email);
    setValid(result);
  };

  return (
    <form
      onSubmit={handleSubmit(onSubmit)}
      className="flex mt-4 lg:mb-8 ml-2 lg:px-2 lg:ml-0 md:w-full md:gap-3"
    >
      <label className="relative md:w-full">
        <input
          className={`bg-transparent border focus:outline-none focus:border-white border-silver text-pearl p-2 mr-2 lg:w-auto md:w-full`}
          placeholder="Email address"
          type="email"
          {...register('emailAddress', {
            required: 'Email is required',
            onChange: (e) => validateEmail(e.target.value),
            pattern: {
              value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,5}$/i,
              message: 'This field must contain a valid email.'
            }
          })}
        />
        {isValid && (
          <div className="absolute top-3.5 right-5">
            <Image
              alt="Success"
              src="/icons/check.svg"
              width={16}
              height={16}
            ></Image>
          </div>
        )}
        {errors.emailAddress && (
          <div className="absolute top-3 right-4">
            <Image
              alt="Error"
              src="/exclamation.svg"
              width={16}
              height={16}
            ></Image>
          </div>
        )}
      </label>
      <button
        type="submit"
        className="bg-cloud uppercase text-onyx w-1/3 lg:w-6/12 p-2 lg:mt-0"
      >
        Sign&nbsp;Up
      </button>
    </form>
  );
}
